export const API_ENDPOINTS = {
  // Patients
  PATIENTS: '/patients',
  PATIENT_BY_ID: (id: number) => `/patients/${id}`,
  PAGED_PATIENTS: '/patients/paged',
  SEARCH_PATIENTS: '/patients/search',

  // Visits
  VISITS: '/visits',
  VISIT_BY_ID: (id: number) => `/visits/${id}`,
  VISITS_BY_PATIENT: (patientId: number) => `/visits/patient/${patientId}`,
  VISIT_FILES: (visitId: number) => `/visits/${visitId}/files`,
  ALL_VISIT_FILES: (patientId: number) => `/patients/${patientId}/all-visit-files`,
  VISIT_FILE_DELETE: (fileId: number) => `/visitfiles/${fileId}`,

  // Prescriptions
  PRESCRIPTIONS: '/prescriptions',
  PRESCRIPTION_BY_ID: (id: number) => `/prescriptions/${id}`,
  PRESCRIPTIONS_BY_VISIT: (visitId: number) => `/prescriptions/visit/${visitId}`,
  DRUG_DOSE_SUGGESTIONS: (patientId: number, drugId: number) => `/prescriptions/suggestions/patient/${patientId}/drug/${drugId}`,
  PRESCRIPTION_INITIAL_DATA: '/prescriptions/initial-data',

  // Master Data
  DRUGS: '/drugs',
  DRUG_BY_ID: (id: number) => `/drugs/${id}`,
  LAB_TESTS: '/lab-tests',
  RADIOLOGY_TESTS: '/radiology-tests',

  // Settings
  PRESCRIPTION_SETTINGS: '/settings/prescription',

  // Printing
  PRINT_PRESCRIPTION: (id: number) => `/print/prescription/${id}`,
  DOWNLOAD_PRESCRIPTION_PDF: (id: number) => `/print/prescription/${id}/pdf`,
  AVAILABLE_PRINTERS: '/print/printers',

  // Auth
  LOGIN: '/auth/login',
};

